import { maxWidth } from '@mui/system';
import { colors } from 'Constants/Colors';

export const ButtonStyle = {
  background: colors.WHITE,
  paddingTop: '1rem',
  paddingBottom: '1rem',
  width: '80%',
  maxWidth: '.5rem',
};

export const IconUserStyle = value => ({
  color: value ? colors.GRAY_SUBMIT : colors.GREEN,
});
export const IconCourseStyle = value => ({
  color: value ? colors.GREEN : colors.GRAY_SUBMIT,
});
export default { ButtonStyle, IconCourseStyle, IconUserStyle };
